import React from "react";
import { CardLayout } from "components/cardLayout";
import { CardSubItem } from "components/cardSubItem";
import { CardTitle } from "components/cardTitle";
import { Button } from "components/button";
import "./Thankyou.scss"
import { CardItem } from "components/cardItem";
import { AddToCalender } from "components/addToCalender";
import moment from "moment";
import { navigate } from "@reach/router";

export interface ThankyouProps {
    title?: string;
    description?: string;
    location?: string;
    startTime?: string | Date;
    endTime?: string | Date;
}

export interface ThankyouState {

}

class Thankyou extends React.Component<ThankyouProps, ThankyouState> {
    constructor(props: ThankyouProps) {
        super(props);
        this.state = {};
    }

    gotoEstDetail() {
        navigate("/estDetail")
    }

    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var estDetails = JSON.parse(localStorage.getItem("EstimatorDetails") || '{}');
        var fname = estDetails.customer


        var moveDate = moment(estDetails.moveDate).format("MM/DD/YYYY");
        if (localStorage.getItem('notsure') == "1") {
            moveDate = "Not sure";
        }
        // if(moveDate.toLowerCase.toString().indexOf('invalid')>=0){
        //     moveDate="Not Sure"
        // }

        return (
            <CardLayout style={{ padding: "2em 1.5em 1em 1.5em", marginBottom: 100 }}>
                <div className="customer-title">
                    <h3>{estDetails.customer}’s Move Day</h3>
                </div>
                <div className="fromAddress">
                    <h3>From Address</h3>
                    <h3>Move Day</h3>
                </div>
                <CardSubItem rightLabel={estDetails.origin} leftLabel={moveDate} />
                <br />
                <div className="fromAddress">
                    <h3>To Address</h3>
                </div>
                <CardSubItem rightLabel={estDetails.des} leftLabel={""} />

                {/* <CardSubItem rightLabel={object.address + ", #"+ object.Unit} leftLabel={moment(object.MoveDate).format("MM/DD/YY")} /> */}
                {/* <div className="thankyou-btn"> */}
                {/* <Button
                width={"55vw"}
                text={"Add to Calendar"}
                style={{padding:" 1em 2em"}}
                fontSize={"1.5rem"}
                />  */}
                <div className="thankyou-btn">
                    <div className="calendar-btn">
                        <AddToCalender
                            title={"Upcoming move with All My Sons"}
                            description={estDetails.MoveSizeDetail || '{}'}
                            location={estDetails.origin || '{}'}
                            startTime={estDetails.moveDate || '{}'}
                            endTime={estDetails.MoveDate || '{}'}
                        >
                        </AddToCalender>

                    </div>
                    {/* <div className="finish-btn">
                        <Button
                            text={"Estimate Details"}
                            width={"36vw"}
                            onClick={this.gotoEstDetail}
                        />
                    </div> */}
                </div>
                {/* </div> */}
            </CardLayout>
        );
    }
}

export default Thankyou;